export const SET_PATHNAME = "SET_PATHNAME";

export const setPathName = (data: any) => {
    return {
      type: SET_PATHNAME,
      payload: data,
    };
  };